export default __webpack_public_path__ + "static/media/redeem-bonus1-1.bcb3303f.webp";